module.exports = __webpack_public_path__ + "img/6.8077d4eb.jpg";